export default __webpack_public_path__ + "static/media/avatar-2.7eed0747.png";